import type { RuleErrorHandlingParams } from '@/libs/validation/ts/rule-constructor-parameter.type.ts'
import { translate } from '@/i18n/i18n.ts'
import { resolveRules } from '@/libs/validation/helpers/configure-rule.helper.ts'

export const useEntryFormRules = () => {
  const errorHandling: RuleErrorHandlingParams = {
    useDefaultErrorMessage: true,
    transformErrorMessage: (message, args) => {
      if (args) {
        return translate(message, args)
      } else {
        return translate(message)
      }
    }
  }

  const deviceClassRules = resolveRules([
    { type: 'required', errorMessage: translate('validation.default_error_messages.required') }
  ])

  const dateRules = resolveRules(
    [
      { type: 'required', errorMessage: translate('validation.purchase_date.required') },
      {
        type: 'date_is_valid',
        errorMessage: translate('validation.default_error_messages.date_is_valid')
      },
      {
        type: 'date_max_age',
        config: {
          max: 6,
          unit: 'months'
        },
        errorMessage: translate(
          'validation.purchase_date.date_max_date',
          '6',
          translate('validation.units.months')
        )
      },
      { type: 'date_not_in_future' }
    ],
    errorHandling
  )

  const priceRules = resolveRules(
    [
      { type: 'required', errorMessage: translate('validation.purchase_price.required') },
      {
        type: 'min',
        config: {
          min: 1
        },
        errorMessage: translate('validation.purchase_price.min', '1')
      },
      {
        type: 'max',
        config: {
          max: 15000
        },
        errorMessage: translate('validation.purchase_price.max', '15000')
      }
    ],
    errorHandling
  )

  return {
    errorHandling,
    deviceClassRules,
    dateRules,
    priceRules
  }
}
